import { defineNuxtPlugin } from '#app'
import { setAuthenticatedCallback, setLogoutCallback } from './composables/useAuth'
import type { TokenResponse } from './types'

export default defineNuxtPlugin((nuxtApp) => {
	let pendingAuthResponse: TokenResponse | undefined
	let pluginsReady = false

	setLogoutCallback(async () => {
		await nuxtApp.callHook('auth:logout')
	})

	setAuthenticatedCallback(async (response: TokenResponse) => {
		if (pluginsReady) {
			await nuxtApp.callHook('auth:authenticated', response)
		} else {
			pendingAuthResponse = response
		}
	})

	nuxtApp.hook('app:created', async () => {
		pluginsReady = true
		if (pendingAuthResponse) {
			await nuxtApp.callHook('auth:authenticated', pendingAuthResponse)
			pendingAuthResponse = undefined
		}
	})
})
